/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $LanguageList = {
    type: 'array',
    contains: {
        type: 'Language',
    },
} as const;
